import Header from '@/components/Header';
import WorkWithUs from '@/components/WorkWithUs';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import { useScrollToHash } from '@/hooks/useScrollToHash';

const WorkWithUsPage = () => {
  useScrollToHash();
  
  return (
    <div className="min-h-screen">
      <Header />
      <SEO
        title="Work With Us | Freeman & Crown Law"
        description="Join our team or explore career opportunities at Freeman & Crown Law. We're looking for dedicated professionals passionate about constitutional law."
        image="/lovable-uploads/f8f9f48d-77d0-4885-9af1-64dd5447bcf5.png"
        url={window.location.origin + '/work-with-us'}
        type="website"
      />
      <WorkWithUs />
      <Footer />
    </div>
  );
};

export default WorkWithUsPage;